export interface CountResponse {
	total: number;
}
